import React from 'react'

import { Grid } from 'semantic-ui-react'
import Layout from '../components/layout'
import AppraisalResults from '../components/appraisal_results'
import AppraisalForm from '../components/appraisal_form'
import AppraisalSummary from '../components/appraisal_summary'
import AppraisalInstructions from '../components/appraisal_instructions'

export default class IndexPage extends React.Component
{
  state = { data: null }

  getQuote(q) {
    if (q === null) {
      this.setState({data:null});
      return;
    }

    fetch('https://api.nothingindustries.com/api/appraise?q=' + q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(responseJson => {
      this.setState({data:responseJson})
    })
    .catch(error => console.error(error))
  }

  componentDidMount()
  {
    window.onpopstate = function (event) {
      let quote = null;
      if (event.state) {
        quote = event.state.q;
      }
      this.getQuote(quote);
    }.bind(this);

    let params = new URLSearchParams(window.location.search);
    if (!params.has('q')) {
      return;
    }
    let quote = params.get('q');
    this.getQuote(quote);
    window.history.replaceState(
      {q: quote},
      document.title,
      '?q=' + quote
    );
  }

  componentWillUnmount()
  {
    window.onpopstate = null;
  }

  onSubmit = (rawData) => {
    fetch('https://api.nothingindustries.com/api/appraise', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: rawData
    })
    .then(response => response.json())
    .then(responseJson => {
      this.setState({data:responseJson})
      window.history.pushState(
        {q: responseJson.id},
        document.title,
        '?q=' + responseJson.id
      );
    })
    .catch(error => console.error(error))
  }

  render() {
    let results = this.state.data ? <AppraisalResults data={this.state.data.items} /> : <AppraisalInstructions />;
    let summary = this.state.data ? <AppraisalSummary data={this.state.data} /> : <></>;
    return (
      <Layout>
        <Grid relaxed stackable>
          <Grid.Column mobile={16} tablet={5} computer={5}>
            <AppraisalForm submitFunction={this.onSubmit} />
            {summary}
          </Grid.Column>

          <Grid.Column mobile={16} tablet={8} computer={11}>
            {results}
          </Grid.Column>
        </Grid>
      </Layout>
    )
  }
}

